import { useQuery } from "@apollo/client/react";
import { DETALLE_ENVIO_LOGISTICA } from "../../../data/graphQL/queries/GestionAsistencial/getDetalleEnvioLogistica";
import { GET_RESUMEN_CONTRATO } from "../../../data/graphQL/queries/GestionAsistencial/getResumenContrato";
import { GET_UME_DIETA } from "../../../data/graphQL/queries/GestionAsistencial/getUMEDieta";

export function useLogisticaDialogRows(idEvaluacion) {
  const { data: resumenDieta, loading: loadingResumenDieta } = useQuery(
    GET_UME_DIETA,
    {
      variables: {
        idEvaluacion
      }
    }
  );

  const { data: resumenContrato, loading: loadingResumenContrato } = useQuery(
    GET_RESUMEN_CONTRATO,
    {
      variables: {
        idEvaluacion
      }
    }
  );

  const { data: resumenEnvio, loading: loadingResumenEnvio } = useQuery(
    DETALLE_ENVIO_LOGISTICA,
    {
      variables: {
        idEvaluacion
      }
    }
  );

  const resumenDietaRows = resumenDieta?.umeDieta || [];
  const resumenContratoRows = resumenContrato?.resumenContrato || [];
  const resumenEnvioRows = resumenEnvio?.detalleEnvioLogistica || [];

  return {
    resumenDietaRows,
    resumenContratoRows,
    resumenEnvioRows,
    loadingResumenDieta,
    loadingResumenContrato,
    loadingResumenEnvio
  };
}